import { PricingBoundaryBreakpointDto } from './pricing-boundary-breakpoint.dto';

/**
 * Pricing boundaries DTO
 */
export class PricingBoundariesDto {
	minTotalGross?: number;
	maxTotalGross?: number;
	breakpoints?: PricingBoundaryBreakpointDto[];
}
